import { ActionIcon, Tooltip } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useDeleteSurvey } from "../../api/survey";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";

const DeleteSurveyModal = ({ surveyId, ...props }) => {
  const { mutate } = useDeleteSurvey(surveyId);
  const confirmDelete = useDeleteConfirm("survey", mutate);

  return (
    <Tooltip label="Delete survey">
      <ActionIcon
        onClick={() => confirmDelete({})}
        color="red"
        variant="light"
        {...props}
      >
        <IconTrash size={24} />
      </ActionIcon>
    </Tooltip>
  );
};

export default DeleteSurveyModal;
